// @flow
import * as React from 'react';

type ManageChannelAlertProps = {
  onClick: Function,
  channelName: string,
};

export default function(props: ManageChannelAlertProps) {
  const buttonText = 'Manage Users & Alerts';
  return (
    <button
      aria-label={`${buttonText} for ${props.channelName}`}
      className="ba bw0 link bg-white blue ma0 v-mid dim pointer nowrap brandon Channel__manage-alerts"
      type="button"
      onClick={props.onClick}
    >
      {buttonText}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/containers/channels/ManageChannelAlertsButton.js